export const analyticsPageViews = {
  catalog: 'Catalog',
  checkout: 'Checkout',
}
